import { render, staticRenderFns } from "./idade-para-aprender-ingles.vue?vue&type=template&id=f229017a&"
import script from "./idade-para-aprender-ingles.vue?vue&type=script&lang=js&"
export * from "./idade-para-aprender-ingles.vue?vue&type=script&lang=js&"
import style0 from "../../assets/site/css/font-awesome.min.css?vue&type=style&index=0&lang=css&"
import style1 from "../../assets/site/css/themify-icons.css?vue&type=style&index=1&lang=css&"
import style2 from "../../assets/site/css/magnific-popup.css?vue&type=style&index=2&lang=css&"
import style3 from "../../assets/site/css/owl.theme.default.min.css?vue&type=style&index=3&lang=css&"
import style4 from "../../assets/site/css/owl.carousel.min.css?vue&type=style&index=4&lang=css&"
import style5 from "../../assets/site/css/bootstrap.min.css?vue&type=style&index=5&lang=css&"
import style6 from "../../assets/site/css/style.css?vue&type=style&index=6&lang=css&"
import style7 from "../../assets/site/css/responsive.css?vue&type=style&index=7&lang=css&"
import style8 from "./idade-para-aprender-ingles.vue?vue&type=style&index=8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "idade-para-aprender-ingles.vue"
export default component.exports